import { USER_ID_COOKIE, getCookie } from '@olxeu-a2b/core/src/utils/cookie';

const useGetUserType = (ids: { buyerId: string; sellerId: string }) => {
  const userId = getCookie(USER_ID_COOKIE);

  const isSeller = userId === ids.sellerId;

  const isBuyer = userId === ids.buyerId;

  const isLoggedUser = isSeller || isBuyer;

  return {
    isSeller,
    isBuyer,
    isLoggedUser,
  };
};

export default useGetUserType;
